// extracted by mini-css-extract-plugin
export var modalCloseCross = "ModalFadeInCenter-module--modal-close-cross--eec33";
export var modalFadeIn = "ModalFadeInCenter-module--modal-fade-in--6f7f7";
export var modalFadeInAnimation = "ModalFadeInCenter-module--modalFadeInAnimation--e5346";
export var modalFadeInCenter = "ModalFadeInCenter-module--modal-fade-in-center--1b621";
export var modalFadeOut = "ModalFadeInCenter-module--modal-fade-out--884fa";
export var modalIsOpen = "ModalFadeInCenter-module--modal-is-open--57298";
export var modalOverlay = "ModalFadeInCenter-module--modal-overlay--1acde";